import {
  getAvailableQuestionSets,
  getConversionOffer,
  getGameSpecificPersonas,
  putAnswersToQuestions,
  getUserLatestAnswers,
} from "../../api/onboarding"
import { MIXINS } from "@/utils/mixins"

const state = {
  currentStep: 0,
  totalSteps: 2,
  afterOnboardingStep: "",
  questions: [],
  answers: [],
  currentAnswer: null,
  conversionOffer: "Pro Membership",
  onboardingContainer: null,
  loading: false,
  questionSet: 0,
  game: null,
  enable: false, // for recommendation setting
  gamePersona: null,
  toSubscription: false,
}

const getters = {
  currentStep: state => state.currentStep,
  totalSteps: state => state.totalSteps,
  afterOnboardingStep: state => state.afterOnboardingStep,
  questions: state => state.questions,
  currentQuestion: state => state.questions[state.currentStep - 2] || {},
  answers: state => state.answers,
  currentAnswer: state => state.currentAnswer,
  conversionOffer: state => state.conversionOffer,
  onboardingContainer: state => state.onboardingContainer,
  loading: state => state.loading,
  enable: state => state.enable,
  gamePersona: state => state.gamePersona,
  game: state => state.game,
}

const mutations = {
  setStep: (state, step) => (state.currentStep = step),
  setTotalSteps: (state, number) => (state.totalSteps = number),
  setAfterOnboardingStep: (state, step) => (state.afterOnboardingStep = step),
  setQuestions: (state, questions) => (state.questions = questions),
  setAnswers: (state, answers) => (state.answers = answers),
  setCurrentAnswer: (state, answer) => (state.currentAnswer = answer),
  setConversionOffer: (state, offer) => (state.conversionOffer = offer),
  setOnboardingContainer: (state, ele) => (state.onboardingContainer = ele),
  setLoading: (state, loading) => (state.loading = loading),
  setQuestionSet: (state, set) => (state.questionSet = set),
  setGame: (state, game) => (state.game = game),
  setEnable: (state, enable) => (state.enable = enable),
  setGamePersona: (state, gamePersona) => (state.gamePersona = gamePersona),
  setToSubscription: (state, toSubscription) =>
    (state.toSubscription = toSubscription),
}

const actions = {
  resetOnboarding ({ commit }) {
    commit("setStep", 0)
    commit("setAfterOnboardingStep", "")
    commit("setTotalSteps", 3)
    commit("setAnswers", [])
    commit("setQuestionSet", 0)
    commit("setQuestions", [])
    commit("setGame", null)
    commit("setEnable", false)
  },
  async addAnswer ({ commit, state }, answer) {
    const answers = state.answers

    let answerIndex = -1
    for (let i in answers) {
      if (answers[i].question_id === answer.question_id) {
        answerIndex = i
        answers[i] = answer
      }
    }
    if (answerIndex === -1) {
      answers.push(answer)
    }
    commit("setCurrentAnswer", answer)
    await commit("setAnswers", answers)
    commit("setEnable", state.answers.length === state.questions.length)
  },
  async getQuestionSets ({ commit, rootGetters }, { game, type }) {
    const gameNameByKey = rootGetters["Game/gameNameByKey"]
    commit("setLoading", true)
    const gameKey = game.name
    commit("setGame", gameNameByKey(gameKey))
    const data = await getAvailableQuestionSets(game.id, type)
    if (data) {
      commit("setQuestions", data.result.questions)
      commit("setQuestionSet", data.result.question_set_id)
      commit("setTotalSteps", data.result.questions.length + 1)
    } else {
      commit("setQuestions", [])
      commit("setQuestionSet", "fake")
      commit("setTotalSteps", 1)
    }
    commit("setAnswers", [])
    commit("setLoading", false)
  },
  goNextStep ({ commit, state }) {
    commit("setStep", state.currentStep + 1)
    commit("setCurrentAnswer", state.answers[state.currentStep - 2])
  },
  goBackStep ({ commit, state }) {
    commit("setStep", state.currentStep - 1)
    commit("setCurrentAnswer", state.answers[state.currentStep - 2])
  },
  // for recommendation setting answers submit
  async putAnswersToQuestions ({ commit, state, rootGetters, dispatch }) {
    commit("setLoading", true)
    const instaProAccessToken = await dispatch(
      "User/Coaching/loadInstaProAccessToken",
      null,
      {
        root: true,
      }
    )
    const body = { answers: state.answers }
    if (state.answers && state.answers.length) {
      commit("setEnable", false)
      await putAnswersToQuestions(state.questionSet, body, instaProAccessToken)
    }
    if (state.game === "League of Legends") {
      if (state.answers[0] && state.answers[0].metadata) {
        MIXINS.methods.trackAnalyticsEvent("Set current LoL rank", {
          rank_name: state.answers[0].metadata.checked_options[0],
        })
      }
      if (state.answers[1] && state.answers[1].metadata) {
        MIXINS.methods.trackAnalyticsEvent("Set goal LoL rank", {
          rank_name: state.answers[1].metadata.checked_options[0],
        })
      }
    }
    commit("setLoading", false)
  },
  async getConversionOffer ({ commit, rootGetters }) {
    const instaProAccessToken =
      rootGetters["User/Coaching/getInstaProAccessToken"]
    const data = await getConversionOffer(instaProAccessToken)
    commit("setConversionOffer", data.result)
  },
  async getGameSpecificPersonas ({ commit, rootGetters }, gameId) {
    const instaProAccessToken =
      rootGetters["User/Coaching/getInstaProAccessToken"]
    const data = await getGameSpecificPersonas(gameId, instaProAccessToken)
    if (data) {
      commit("setGamePersona", data.result)
    } else {
      commit("setGamePersona", null)
    }
  },
  async getUserLatestAnswers ({ commit, state, rootGetters }) {
    const instaProAccessToken =
      rootGetters["User/Coaching/getInstaProAccessToken"]
    const data = await getUserLatestAnswers(
      state.questionSet,
      instaProAccessToken
    )
    await commit("setAnswers", data.result)
    commit("setEnable", state.answers.length === state.questions.length)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/onboarding.js